<template>
  <span v-if="isValuePresent(value1) || isValuePresent(value2) || !hideIfNoData">
    <strong v-if="title">{{ title }}</strong>
    <span v-if="isValuePresent(value1) || isValuePresent(value2)">
      <BuildingDimensionLabel :value="value1" />
      <!-- Vue 3 drops the newline between the two labels that Vue 2 kept as a space. -->
      <span v-if="isValuePresent(value2)">
        {{ ` ${separator}` }} <BuildingDimensionLabel :value="value2" />
      </span>
    </span>
    <span v-else-if="hideIfNoData" />
    <Label v-else />
  </span>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue';

import { Nullable } from '@/utils/types';
import { isValuePresent } from '@/bundles/App/helpers/isValuePresent';

import Label from '@/bundles/Common/components/Label.vue';

import BuildingDimensionLabel from './BuildingDimensionLabel.vue';

export default defineComponent({
  name: 'BuildingDimensionLabels',

  components: {
    Label,
    BuildingDimensionLabel
  },

  props: {
    title: {
      type: String,
      default: null
    },
    value1: {
      type: [String, Number] as PropType<Nullable<string | number>>,
      default: null
    },
    value2: {
      type: [String, Number] as PropType<Nullable<string | number>>,
      default: null
    },
    separator: {
      type: String,
      default: '-'
    },
    hideIfNoData: Boolean
  },

  methods: {
    isValuePresent
  }
});
</script>
